import { Box, Container, Grid, Theme, useTheme } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { FC, useRef, useState } from "react";
import { Animated } from "react-animated-css";
import AppleStore from '../../../assets/applestore.svg';
import DevicesImg from '../../../assets/images/devices.png';
import Logo from '../../../assets/images/logo.png';
import BgImage from '../../../assets/images/mobile-app-section-bg.png';
import PlayStore from '../../../assets/playstore.svg';
import { images } from "../../../constants/assets";
import useOnScreen from "../../../hooks/useOnScreen";
import AppButton from "../../common/Button/AppButton";
import AppModal from "../../common/Modal/AppModal";
import Text from "../../common/Text";
import Slider, { Settings } from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import NewIcon1 from '../../../assets/companyLogos/new/appLogo/icon1.png';
// import NewIcon2 from '../../../assets/companyLogos/new/appLogo/icon2.png';
import NewIcon3 from '../../../assets/companyLogos/new/appLogo/icon3.png';
import NewIcon4 from '../../../assets/companyLogos/new/appLogo/icon4.png';
import NewIcon5 from '../../../assets/companyLogos/new/appLogo/icon5.png';
import NewIcon6 from '../../../assets/companyLogos/new/appLogo/icon6.png';
import NewIcon7 from '../../../assets/companyLogos/new/appLogo/icon7.png';
import NewIcon8 from '../../../assets/companyLogos/new/appLogo/icon8.png';
import NewIcon9 from '../../../assets/companyLogos/new/appLogo/icon9.png';


interface FeatureProps {
    icon: string
    title: string
    desc: string
}

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        padding: theme.spacing(19, 0),
        backgroundImage: `url("${BgImage}")`,

        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(8, 0),
        },
        position: 'relative',
        backgroudColor: '#fff',
        zIndex: 99,
    },
    mobileAppArea: {
        paddingTop: 100,

        '& .mobile': {
            maxWidth: '30rem',
            height: 'auto'
        },


        [theme.breakpoints.down('md')]: {
            paddingTop: 50,

            '& .mobile': {
                width: '100%',
                maxWidth: '30rem',
                height: 'auto',
                paddingBottom: 26
            },
        }
    },
    icon: {
        width: 48,
        height: 48,
        marginBottom: 24,

        [theme.breakpoints.down('md')]: {
            marginBottom: 8,
            marginTop: 24
        }
    },
    featureTitle: {
        textAlign: 'center',
        marginBottom: 16,
        color: theme.palette.common.white,
        fontSize: 22,
        fontWeight: 500,

        [theme.breakpoints.down('md')]: {
            fontSize: 20,
            marginBottom: 0,
        }
    },
    featureDesc: {
        lineHeight: '20px',
        fontSize: 14,
        color: theme.palette.common.white,
        textAlign: 'center',

        [theme.breakpoints.down('md')]: {
            fontSize: 12,
            maxWidth: '97%'
        }
    },
    platformCard: {
        background: theme.palette.custom.gradiantPrimary,
        display: 'block',
        textAlign: 'center',
        padding: theme.spacing(3),
        borderRadius: 12,
        '& img': {
            maxWidth: '100%',
            height: 'auto',
        }
    },
    headingImgArea: {
        maxWidth: '100%',
        display: 'flex',
        justifyContent: 'center',
        '& img': {
            maxWidth: '35rem',
            height: 'auto',
        },
        [theme.breakpoints.down('lg')]: {
            '& img': {
                maxWidth: '22rem',
            },
        },
        [theme.breakpoints.down('md')]: {
            '& img': {
                maxWidth: '20rem',
            },
        },
        [theme.breakpoints.down('sm')]: {
            '& img': {
                maxWidth: '16rem',
            },
        }
        
    },
    logoArea: {
        paddingTop: theme.spacing(10.5),
        // paddingTop: theme.spacing(19),
        '& .slide': {
            display: 'flex !important',
            justifyContent: 'center',
            alignItems: 'center',

            '& img': {
                maxWidth: '6rem',
                height: '6rem'
            },
            [theme.breakpoints.down('md')]: {
                '& img': {
                    maxWidth: '3rem',
                    height: '3rem'
                }
            }
        },

        [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(10),
        }

    }
    
}))

const Feature: FC<FeatureProps> = ({
    icon,
    title,
    desc
}) => {
    const classes = useStyles()

    return (
        <Box display='flex' flexDirection='column' justifyContent='center' alignItems='center'>
            <img className={classes.icon} alt='icon' src={icon} />
            <Text className={classes.featureTitle}>{title}</Text>
            <Text className={classes.featureDesc}>{desc}</Text>
        </Box>
    )
}

const MobileAppSection = () => {
    const classes = useStyles()
    const ref = useRef(null)
    const onScreen = useOnScreen(ref, "-180px");
    
    const [features, setFeatures] = useState([
        {
            icon: images.AdFree,
            title: 'Ad free content',
            desc: 'No to distracting & whoops advertisements.'
        },
        {
            icon: images.Download,
            title: 'Download option',
            desc: 'All set to watch offline whenever free.'
        },
        {
            icon: images.FeaturedPlayer,
            title: 'Modern player',
            desc: 'Touch-Play-Verb feature wipe your hurdles out while streaming.'
        },
        {
            icon: images.SeamlessStreaming,
            title: 'Seamless streaming',
            desc: 'Buffer less & stream more with ProReal.'
        },
    ])
    const [openModal, setOpenModal] = useState(false)


    const handleToggleModal = () => {
        setOpenModal(!openModal)
    }
    const theme = useTheme()

    const [sliderSettings] = useState<Settings>({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        speed: 2000,
        autoplaySpeed: 2000,
        cssEase: "linear",
        arrows: false,
        responsive: [
            {
                breakpoint: theme.breakpoints.values.md,
                settings: {
                    slidesToShow: 4,
                }
            }
        ]
    })

    return (
        <Box ref={ref} className={`${classes.root} mobileAppSection`} component='section' id='mobileAppSection'>
            <Container>
                <Animated animationIn="fadeInUp" animationOut="fadeInUp" isVisible={onScreen} animateOnMount={false}>
                    <Box className={classes.headingImgArea}>
                        <img src={Logo} alt='heading image' />
                    </Box>
                </Animated>
                <Grid container className={classes.mobileAppArea}>
                    <Grid item xs={12} md={6} display='flex' justifyContent='center'>
                        <img className="mobile" alt='mobile' src={DevicesImg} />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid spacing={3} height='100%' container>
                            {
                                features.map((feature, index) => (
                                    <Grid item xs={12} sm={6} key={feature.title}>
                                        <Animated animationIn="fadeInUp" animationOut="fadeInUp" isVisible={onScreen} animateOnMount={false} animationInDelay={500 + (500 * (index + 1))}>
                                            <Feature icon={feature.icon} title={feature.title} desc={feature.desc} />
                                        </Animated>
                                    </Grid>
                                ))
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={12} md={12} mt={10} display='flex' justifyContent='center'>
                        <AppButton onClick={handleToggleModal} variant='contained'>Download for FREE</AppButton>
                    </Grid>
                </Grid>
                <h2>Experience a world of entertainment like never before with our newly launched FAST channels, now available worldwide.</h2>
                <Slider {...sliderSettings} className={classes.logoArea}>
                    
                    <Box className='slide'>
                        <img src={NewIcon1} alt='img1' />
                    </Box>
                    {/* <Box className='slide'>
                        <img src={NewIcon2} alt='img2' />
                    </Box> */}
                    <Box className='slide'>
                        <img src={NewIcon3} alt='img3' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon4} alt='img4' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon5} alt='img5' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon6} alt='img6' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon7} alt='img7' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon8} alt='img8' />
                    </Box>
                    <Box className='slide'>
                        <img src={NewIcon9} alt='img9' />
                    </Box>
                    {/* <Box className='slide'>
                        <img src={Icon5} alt='img5' />
                    </Box> */}
                </Slider>
            </Container>
            
            <AppModal
                open={openModal}
                onClose={handleToggleModal}
                title='Choose your platform'
                fullWidth
                maxWidth='xs'
            >
                <Grid container spacing={3}>
                    <Grid item xs={6}>
                        <Box component={'a'} target='_blank' href='https://play.google.com/store/apps/details?id=com.proreal.mobile' className={classes.platformCard}>
                            <img src={PlayStore} alt='play store' />
                            <Text color='white' mt={2}>Download from <br /> <strong>Google Play</strong></Text>
                        </Box>
                    </Grid>
                    <Grid item xs={6}>
                        <Box component={'a'} target='_blank' href='https://apps.apple.com/app/proreal/id1633390819' className={classes.platformCard}>
                            <img src={AppleStore} alt='apple store' />
                            <Text color='white' mt={2}>Download from <br /> <strong>App Store</strong></Text>
                        </Box>
                    </Grid>
                </Grid>
            </AppModal>
        </Box>
    )
}

export default MobileAppSection